<template>
<div class="container">
  <div class="row">
    <div id="doc" class="col-xs-11 col-md-12">    
      <div>    
      <h2 class="title">新元号に関する商品</h2>
      </div>
      <div class="container">
        <div class="row">
          <div id ="script" ></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'shopping',
  data: () => {
    return {};
  },
  components: {
    
  },
  watch: {
    $route (to, from) {
      // ルートの変更の検知...
      
    }
  },
  beforeRouteUpdate (to, from, next) {
    console.log('$route change')
  },
  mounted(){
    console.log('ready');
    console.log(this.$route);
    let scriptDiv = document.getElementById('script');
    let script1 = 'amzn_assoc_ad_type ="responsive_search_widget"; amzn_assoc_tracking_id ="r4hs-22"; amzn_assoc_marketplace ="amazon"; amzn_assoc_region ="JP"; amzn_assoc_placement =""; amzn_assoc_search_type = "search_widget";amzn_assoc_width ="auto"; amzn_assoc_height ="auto"; amzn_assoc_default_search_category =""; amzn_assoc_default_search_key ="令和";amzn_assoc_theme ="light"; amzn_assoc_bg_color ="FFFFFF"; ';
    let elem1 = document.createElement('script');
    elem1.text = script1;
    let elem2 = document.createElement('script');
    elem2.setAttribute('src', '//z-fe.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&Operation=GetScript&ID=OneJS&WS=1&Marketplace=JP');
    scriptDiv.appendChild(elem1);
    scriptDiv.appendChild(elem2);
  },


}
</script>

<style>
  .content {
    background-color:#fefefe;
  }
</style>

